<template>
    <div id="login" style="text-align: center;">
        <p style="font-size: 30px; padding-top: 30px">Herzlich Willkommen bei</p>
        <img style="width: 60%" src="/assets/logo.png">
        <p style="font-size: 30px;">Das Portal für partnerschaftliches Bauen.</p>
        <div style="margin-top: 3%;" class="row">
            <div class="col-lg-4 col-md-6 col-sm-10 custom-form">
                <div class="ibox text-center">
                     
                    <h4 class="custom-form-header">{{$t('message.logIn')}}</h4>
                    <div class="ibox-body">
                        <div class="form">
                            <div class="row text-center">
                                <div class="col-md-12 form-group">
                                    <div class="input-group-icon right">
                                        <div class="input-icon"><i class="fa fa-envelope"></i></div>
                                        <input v-model="email" type="email" class="form-control"
                                               :placeholder="$t('message.email')">
                                    </div>
                                </div>
                                <div class="col-md-12 form-group">
                                    <div class="input-group-icon right">
                                        <div class="input-icon"><i class="fa fa-lock font-16"></i></div>
                                        <input v-model="password" type="password" 
                                                @keyup.enter="log"
                                                class="form-control"
                                               :placeholder="$t('message.password')">
                                    </div>
                                </div>
                                <div class="col-md-12 form-group text-left">
                                    <div style="display: inline-block; width: 49.5%;">
                                        <label class="ui-checkbox ui-checkbox-gray custom-form-remember-me-label"
                                               for="remember-me">
                                            <input v-model="rememberMe" id="remember-me" type="checkbox"
                                                   class="form-control">
                                            <span class="input-span"></span>
                                            {{$t('message.rememberMe')}}
                                        </label>
                                    </div>
                                    <div style="display: inline-block; width: 49.5%; text-align: right;">
                                        <router-link :to="{name: 'ForgotPassword'}">{{$t('message.forgotPassword')}}
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn btn-primary custom-form-button" @click.prevent="log" >
                                        {{$t('message.logIn')}}
                                    </button>
                                </div>
                                <div class="col-md-12">
                                    <p v-if="errorMessage" class="custom-form-error-message">{{$t('message.' +
                                        errorMessage)}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <p><a href="https://wirbauengerne.ch" style="font-size:25px; color: black;">zurück zu wir<span style="color:#EE6E28">bauen</span>gerne.ch</a></p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        email: '',
        password: '',
        errorMessage: null,
        rememberMe: false
      }
    },
    methods: {
        log () {
        let self = this
        
        this.logIn(this.email, this.password, this.rememberMe)
          .then(() => {
          console.log(this.$store.getters.getAuth['userType']) 
          if(this.$store.getters.getAuth['userType'] === 'craftsmen')
             self.$router.push({name: 'CraftsmenDashboard'})
          else
             self.$router.push({name: 'Dashboard'})
          })
          .catch((err) => {
            if (err.response.data['detail'] === 'Account not active') {
              self.errorMessage = 'accountNotActive'
            } else {
              self.errorMessage = 'invalidCredentials'
            }
             setTimeout(function(){
                self.errorMessage = null
                     }, 3000)
          })
       } 
    }
  }
</script>

<style>
    @media screen and (max-width: 575px) {
        .custom-form {
            margin: 2%;
        }
    }
</style>